import { Component, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { from } from 'rxjs';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { AnalyticsServicesNameEnum } from 'src/app/core/services/analytics/enums/analytics-services-name.enum';
import { PostJobsService } from 'src/app/pages/post-jobs/services/post-jobs.service';
import { EventTrackingEnum } from 'src/app/shared/enums/event-tracking.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IdVerificationModalService } from 'src/app/shared/services/id-verification-modal.service';

@Component({
  selector: 'app-create-job-popup',
  templateUrl: './create-job-popup.component.html',
  styleUrls: ['./create-job-popup.component.scss'],
})
export class CreateJobPopupComponent {
  // The source from where the modal is opened.
  @Input() source: string;

  // The origin from what event triggered the job creation. This is later saved as part of the draft and posted job.
  @Input() origin: string;

  modalReference; // a reference to current modal page used to close the modal

  constructor(
    private modalController: ModalController,
    private navCtrl: NavController,
    public auth: AuthService,
    private analyticsService: AnalyticsService,
    private postJobsService: PostJobsService,
    private idVerificationModalService: IdVerificationModalService,
  ) {}

  async ionViewDidEnter() {
    // store the current modal page reference
    this.modalReference = await this.modalController.getTop();
    this.analyticsService.page(
      EventTrackingEnum.JOBTYPE_SELECTION,
      { object_target: EventTrackingEnum.JOBTYPE_SELECTION, object_type: 'Page' },
      AnalyticsServicesNameEnum.SEGMENT_SERVICE,
    );
  }

  /**
   * close modal
   *
   */
  closeModal() {
    this.modalReference.dismiss();
  }

  /**
   * Create a flex job
   *
   */
  createFlexJob = (): void => {
    this.idVerificationModalService
      .showVerificationModalIfNeeded$()
      .pipe(
        take(1),
        filter((canProceed) => canProceed),
        switchMap(() =>
          from(
            this.navCtrl.navigateForward(['flex/jobs/create/info'], {
              queryParams: {
                ...(this.source ? { source: this.source } : {}),
                ...(this.origin ? { origin: this.origin } : {}),
              },
            }),
          ),
        ),
      )
      .subscribe(() => this.closeModal());
  };

  /**
   * Create a regular job
   *
   */
  createRegularJob = (): void => {
    this.idVerificationModalService
      .showVerificationModalIfNeeded$()
      .pipe(
        take(1),
        filter((canProceed) => canProceed),
        tap(() => {
          this.postJobsService.initialiseSideNavigation('public');
          this.closeModal();
          this.postJobsService.getDraftJobDetails('public', null, {
            source: this.source,
            origin: this.origin,
          });
        }),
      )
      .subscribe();
  };
}
